<template>
  <div class="row FormContainer buttonContainer">
    <template v-if="showBack">
      <v-btn v-if="typeof returnTo == 'function'" @click="returnTo" color="secondary" class="col-xs-4">
        <slot name="back">
          {{ $vuetify.lang.t('$vuetify.common.back') }}
        </slot>
      </v-btn>
      <a v-else-if="!!homeLink" :href="homeLink" class="col-xs-4">
        <v-btn color="secondary">
          {{ $vuetify.lang.t('$vuetify.common.home') }}
        </v-btn>
      </a>
      <router-link v-else-if="returnTo" :to="{name: returnTo, params: storeId}" class="col-xs-4">
        <v-btn color="primary" outlined>
          <slot name="back">
            {{ $vuetify.lang.t('$vuetify.common.back') }}
          </slot>
        </v-btn>
      </router-link>
    </template>

    <div @click="checkValidation" class="col-xs">
      <v-btn color="primary" :disabled="!readyToProceed" :loading="$parent.inprogress" @click="onClick">
        <slot name="continue">
          {{ $vuetify.lang.t('$vuetify.common.continue') }}
        </slot>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showBack: {
      type: Boolean,
      default: true
    },

    returnTo: {
      type: [ String, Function ],
      required: true
    },

    checkValidation: {
      type: Function,
      required: true
    },

    readyToProceed: {
      type: Boolean,
      required: true
    },

    onClick: {
      type: Function,
      required: true
    }
  },

  computed: {
    homeLink() {
      if (this.returnTo == 'FeatureSelect')
        return this.$parent.$parent.$parent.returnUrl
      return null
    },

    ...mapGetters({
      storeId: 'getStoreID',
    })
  },
}
</script>

<style scoped>
  .buttonContainer {
    margin-bottom: 30px;
  }

  .row {
    margin: 0px !important;
    padding: 0px !important;
  }
  .col-xs-4 {
    min-width: 110px !important;
    padding-left: 0px !important;
  }
  .col-xs {
    padding-right: 0px !important;
  }

  .v-btn {
    font-size: 16px;
    font-weight: 700;
    color: white;

    width: 100%;

    padding: 0px !important;
  }

  .v-btn.accent span {
      color: #fff !important;
  }

  a {
    text-decoration: none;
  }
</style>
